export function getTravelCreationMessage(tariffTier = '') {
    if (tariffTier === 'basic') {
        return 'План поездки успешно создан с тарифом «Базовый». При редактировании поездки его легко изменить на «Продвинутый» или «Профи».';
    }
    if (tariffTier === 'advanced') {
        return 'План поездки успешно создан с тарифом «Продвинутый». При редактировании поездки его легко изменить на «Профи».';
    }
    return 'План поездки успешно создан!';
}
